// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   BOX DE PAIEMENT — état "bientôt disponible"
   ============================================================ */

.payment_box {
    position: relative;
    overflow: visible;
}

.payment_box.coming_soon {
    opacity: 0.55;
    filter: grayscale(60%);
}

.payment_box.coming_soon:hover {
    opacity: 0.75;
}

.payment_badge {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #ff8a00;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    padding: 3px 7px;
    border-radius: 999px;
    box-shadow: 0 2px 6px rgba(255, 138, 0, 0.35);
    white-space: nowrap;
    line-height: 1;
}

/* ============================================================
   ALERTE "MODE DE PAIEMENT INDISPONIBLE"
   ============================================================ */

.payment_unavailable_note {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: #fff7ed;
    border: 1px solid #fdba74;
    border-radius: 12px;
    padding: 14px 16px;
    margin-top: 4px;
    animation: paymentFadeIn 0.2s ease-out;
}

.payment_unavailable_icon {
    flex-shrink: 0;
    color: #ea580c;
    margin-top: 2px;
}

.payment_unavailable_text_wrap {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.payment_unavailable_title {
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    color: #9a3412;
}

.payment_unavailable_text {
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
    color: #b45309;
}

@keyframes paymentFadeIn {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* COUPON */
.coupon_box {
    margin-bottom: 14px;
}

.coupon_input_row {
    display: flex;
    gap: 8px;
}

.coupon_input {
    flex: 1 1;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
}

.coupon_input:disabled {
    background: #f5f5f5;
    color: #999;
}

.coupon_btn {
    white-space: nowrap;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid #222;
    background: #222;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
}

.coupon_btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.coupon_btn_remove {
    background: #fff;
    color: #b91c1c;
    border-color: #b91c1c;
}

.coupon_error {
    margin: 6px 0 0;
    font-size: 13px;
    color: #b91c1c;
}

.coupon_success {
    margin: 6px 0 0;
    font-size: 15px;
    color: #15803d;
}

.content_reduction {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #15803d;
    margin-top: 4px;
    padding: 10px 0;
}

.content_total_final {
    font-weight: 700;
    font-size: 16px;
    margin-top: 8px;
    padding-top: 8px;
    /* border-top: 1px solid #e5e5e5; */
}

.payment_summary{
    border: 1px solid var(--gris-secondaire);
    border-radius: 8px;
    padding: 12px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/paiements/PaymentMethodSelector.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,6CAA6C;IAC7C,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;iEAEiE;;AAEjE;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,WAAW;AACX;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":["/* ============================================================\n   BOX DE PAIEMENT — état \"bientôt disponible\"\n   ============================================================ */\n\n.payment_box {\n    position: relative;\n    overflow: visible;\n}\n\n.payment_box.coming_soon {\n    opacity: 0.55;\n    filter: grayscale(60%);\n}\n\n.payment_box.coming_soon:hover {\n    opacity: 0.75;\n}\n\n.payment_badge {\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    background: #ff8a00;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    padding: 3px 7px;\n    border-radius: 999px;\n    box-shadow: 0 2px 6px rgba(255, 138, 0, 0.35);\n    white-space: nowrap;\n    line-height: 1;\n}\n\n/* ============================================================\n   ALERTE \"MODE DE PAIEMENT INDISPONIBLE\"\n   ============================================================ */\n\n.payment_unavailable_note {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    background: #fff7ed;\n    border: 1px solid #fdba74;\n    border-radius: 12px;\n    padding: 14px 16px;\n    margin-top: 4px;\n    animation: paymentFadeIn 0.2s ease-out;\n}\n\n.payment_unavailable_icon {\n    flex-shrink: 0;\n    color: #ea580c;\n    margin-top: 2px;\n}\n\n.payment_unavailable_text_wrap {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.payment_unavailable_title {\n    margin: 0;\n    font-weight: 700;\n    font-size: 14px;\n    color: #9a3412;\n}\n\n.payment_unavailable_text {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: #b45309;\n}\n\n@keyframes paymentFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-4px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* COUPON */\n.coupon_box {\n    margin-bottom: 14px;\n}\n\n.coupon_input_row {\n    display: flex;\n    gap: 8px;\n}\n\n.coupon_input {\n    flex: 1;\n    border: 1px solid #d9d9d9;\n    border-radius: 8px;\n    padding: 8px 12px;\n    font-size: 14px;\n}\n\n.coupon_input:disabled {\n    background: #f5f5f5;\n    color: #999;\n}\n\n.coupon_btn {\n    white-space: nowrap;\n    padding: 8px 16px;\n    border-radius: 8px;\n    border: 1px solid #222;\n    background: #222;\n    color: #fff;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.coupon_btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.coupon_btn_remove {\n    background: #fff;\n    color: #b91c1c;\n    border-color: #b91c1c;\n}\n\n.coupon_error {\n    margin: 6px 0 0;\n    font-size: 13px;\n    color: #b91c1c;\n}\n\n.coupon_success {\n    margin: 6px 0 0;\n    font-size: 15px;\n    color: #15803d;\n}\n\n.content_reduction {\n    display: flex;\n    justify-content: space-between;\n    font-size: 14px;\n    color: #15803d;\n    margin-top: 4px;\n    padding: 10px 0;\n}\n\n.content_total_final {\n    font-weight: 700;\n    font-size: 16px;\n    margin-top: 8px;\n    padding-top: 8px;\n    /* border-top: 1px solid #e5e5e5; */\n}\n\n.payment_summary{\n    border: 1px solid var(--gris-secondaire);\n    border-radius: 8px;\n    padding: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
